import { Link } from 'react-router-dom'

export function AccessNotice({ title = 'This workspace is read-only', message }: { title?: string; message: string }) {
  return <div className="card mx-auto max-w-2xl p-8 text-center" role="status">
    <p className="eyebrow">Access restricted</p>
    <h1 className="mt-3 font-display text-3xl font-extrabold">{title}</h1>
    <p className="mx-auto mt-4 max-w-lg text-sm leading-6 text-ink-700">{message}</p>
    <Link className="button-secondary mt-7" to="/app">Return to overview</Link>
  </div>
}
